// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"b82e9ef0","476":"b82e9ef0","490":"b82e9ef0","545":"b82e9ef0","797":"b82e9ef0","981":"b82e9ef0"}[chunkId] + ".chunk.css";
};